module.exports = {
          srcSet: "/_next/static/images/office-365-465-9092dc6b1f17f2ccd394db140e83e4c0.webp"+" 465w",
          images:[ {path: "/_next/static/images/office-365-465-9092dc6b1f17f2ccd394db140e83e4c0.webp",width: 465,height: 107}],
          src: "/_next/static/images/office-365-465-9092dc6b1f17f2ccd394db140e83e4c0.webp",
          toString:function(){return "/_next/static/images/office-365-465-9092dc6b1f17f2ccd394db140e83e4c0.webp"},
          
          width: 465,
          height: 107
        }